
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProviderDueDiligenceClient } from '@/services/DueDiligenceServices';
import RiskLevelLegendModal from '@/components/modals/riskLevelLegendModal.vue';
import ImportCertificatesModal from '../modals/importCertificatesModal.vue';
import * as DDM from '@/dueDiligenceModels';

@Options({})
export default class ProviderDueDiligence extends Vue {

    @Prop() providerIdentifier: string;

    profiles: DDM.ProviderCompanyProfile[] = [];
    details: { [key: string]: DDM.ProviderProfileDetailVM } = {};
    loading: boolean = true;
    unlinkedProfiles: DDM.ProviderCompanyProfile[] = [];
    loadingUnlinked: boolean = false;
    selectedProfileId: string = '';

    created() {
        this.loadData();
    }

    loadData() {
        this.loading = true;
        ProviderDueDiligenceClient.getByProviderEntity(this.providerIdentifier)
        .then(x => {
            this.profiles = x;
            if (this.profiles.length == 0) {
                this.loadUnlinkedProfiles();
            }
            // Load details for profiles with survey completed
            var detailPromises = this.profiles
                .filter(p => p.status >= DDM.ProviderProfileStatus.SurveyCompleted)
                .map(p =>
                    ProviderDueDiligenceClient.getProviderProfileDetail(p.identifier)
                    .then(d => { this.details[p.identifier] = d; })
                );
            return Promise.all(detailPromises);
        })
        .then(() => {
            this.loading = false;
        });
    }

    loadUnlinkedProfiles() {
        this.loadingUnlinked = true;
        ProviderDueDiligenceClient.getUnlinkedProfiles(false)
        .then(x => {
            this.unlinkedProfiles = x;
            this.loadingUnlinked = false;
        });
    }

    linkProfile() {
        if (!this.selectedProfileId) return;
        const linkedProfileId = this.selectedProfileId;
        ProviderDueDiligenceClient.linkToProvider(linkedProfileId, this.providerIdentifier)
        .then(() => {
            this.selectedProfileId = '';
            this.unlinkedProfiles = [];
            return ProviderDueDiligenceClient.previewCertificateImport(linkedProfileId);
        })
        .then(preview => {
            if (preview && (preview.matched.length > 0 || preview.unmatched.length > 0)) {
                this.$opModal.show(ImportCertificatesModal, {
                    profileId: linkedProfileId,
                    preview: preview
                }, () => this.loadData());
            } else {
                this.loadData();
            }
        });
    }

    viewDetail(profile: DDM.ProviderCompanyProfile) {
        this.$router.push('/due-diligence/' + profile.identifier);
    }

    getStatusLabel(status: DDM.ProviderProfileStatus): string {
        return DDM.getStatusLabel(status);
    }

    getStatusBadge(status: DDM.ProviderProfileStatus): string {
        switch (status) {
            case DDM.ProviderProfileStatus.Invited: return 'bg-secondary';
            case DDM.ProviderProfileStatus.Accepted: return 'bg-info';
            case DDM.ProviderProfileStatus.DataCompleted: return 'bg-primary';
            case DDM.ProviderProfileStatus.SurveyCompleted: return 'bg-success';
            default: return 'bg-secondary';
        }
    }

    showRiskLevelLegend() {
        this.$opModal.show(RiskLevelLegendModal, {
            closeCb: () => { this.$opModal.closeLast(); }
        });
    }

    getRiskLevelLabel(level: DDM.RiskLevel | null): string {
        if (level == null) return 'N/A';
        return DDM.getRiskLevelLabel(level);
    }

    getRiskLevelClass(level: DDM.RiskLevel | null): string {
        if (level == null) return '';
        return DDM.getRiskLevelClass(level);
    }
}
